import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { InfoBar } from './components/InfoBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'nb';
    document.title = 'LØPEKLAR™ – Hele løpeåret ferdig planlagt for løpetrenere';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ihuyy5jpw5en">
      <div lang="nb" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mkrdnl64zhdb">
        <InfoBar data-id="element-2" data-mp="3rbrakqf99zft" />
        <main data-id="element-3" data-mp="3rdaq2et386gj">
          <Hero data-id="element-4" data-mp="3rcsxpt9jqcdw" />
          <StatsBar data-id="element-5" data-mp="3rd17vdeab3le" />
          <Difference data-id="element-6" data-mp="5yjetptzbev" />
          <Recognize data-id="element-7" data-mp="6hpnd64cbd2" />
          <WhatsInside data-id="element-8" data-mp="4n4pyuukj8z" />
          <InsidePages data-id="element-9" data-mp="56lhc8rh1lf" />
          <Bonuses data-id="element-10" data-mp="2zl3azit8d249" />
          <HowItWorks data-id="element-11" data-mp="2zllduyaeeel5" />
          <Audience data-id="element-12" data-mp="2zmepodo7rua5" />
          <Offer data-id="element-13" data-mp="2zmwit1fkxsdu" />
          <Guarantee data-id="element-14" data-mp="2zng0ch1bierc" />
          <Faq data-id="element-15" data-mp="33mf0zpg0npcz" />
          <FinalCta data-id="element-16" data-mp="33lwzoeehyky7" />
        </main>
        <Footer data-id="element-17" data-mp="33mymth8sexwa" />
      </div>
    </MotionConfig>;
}